<template>
  <!-- Drop-in replacement for a YouTube <iframe>; fills the parent .o-video box.
       Loads the heavy YouTube player only after the user clicks. -->
  <div
    class="ytlite"
    :class="{ 'ytlite--on': activated }"
    :style="posterStyle"
    role="button"
    tabindex="0"
    :aria-label="'Play video: ' + title"
    @click="activate"
    @keydown.enter="activate"
    @keydown.space.prevent="activate"
  >
    <iframe
      v-if="activated"
      :src="embedSrc"
      :title="title"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowfullscreen
    ></iframe>
    <span v-else class="ytlite__play" aria-hidden="true"></span>
  </div>
</template>

<script>
export default {
  name: 'YouTubeLazy',
  props: {
    id: { type: String, required: true },
    title: { type: String, default: 'YouTube video player' },
    params: { type: String, default: '' }
  },
  data() {
    return { activated: false }
  },
  computed: {
    posterStyle() {
      return {
        backgroundImage: `url(https://i.ytimg.com/vi/${this.id}/hqdefault.jpg)`
      }
    },
    embedSrc() {
      const base = `https://www.youtube.com/embed/${this.id}?autoplay=1&rel=0`
      return this.params ? `${base}&${this.params}` : base
    }
  },
  methods: {
    activate() {
      this.activated = true
    }
  }
}
</script>

<style scoped>
.ytlite {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #9000ffcc;
  background-position: center;
  background-size: cover;
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
}
.ytlite > iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
}
.ytlite__play {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 68px;
  height: 48px;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.55);
  transition: background 0.2s ease;
}
.ytlite:hover .ytlite__play {
  background: #f00;
}
.ytlite__play::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 52%;
  transform: translate(-50%, -50%);
  border-style: solid;
  border-width: 11px 0 11px 19px;
  border-color: transparent transparent transparent #fff;
}
</style>
